export const public_key = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmI3MZsnbsPUJJDmbyATL
zAAn8FMZbhQh8cA2pw4Sxh+c6VHkT8e1ppFXtuzMmxCwEL+9sE0hQQrJLEUUgXy5
OHngCySFwsZlTBQEsxXtiTOaNnAfxNf9VH7vMxyeY3F354B7561BEh7JuYyIBERC
qy34K7ZUL46jHJXHvcq/4YnIS2PrOHRy/eb5V56GS/t6yoSM9FWLq3QAJpMFM0Ij
IS2IF7EZHoir8NPmH8XO0zdD0+F0tqNaGpAOBZGPHQdqbYRG94Fjn6U/0y334YZQ
DbKF0Z5mJP7/jzLq0DsIZb7X9qifMw1Re+08ouYnTT08sCPTm6ARXTpHWZDR5D1K
cQIDAQAB
-----END PUBLIC KEY-----`
